import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import { useUserDocument } from '../../services/contexts/UserDocumentContext';
import { CnpjMask } from '../../utils/CnpjMask';
import { CpfMask } from '../../utils/CpfMask';
import { Button, Container, Select, SelectContainer } from './styles';

export const Header = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { documentSelected, setDocumentSelected, documents } =
    useUserDocument();

  return (
    <Container>
      <div className="welcomeContainer">
        <span> Bem-vindo(a), {user.name}</span>
        {documents && documents.length > 0 && (
          <div>
            <span>Selecione a empresa:</span>
            <SelectContainer>
              <Select
                value={documentSelected}
                onChange={(event) => setDocumentSelected(event.target.value)}
              >
                {documents?.map((document) => (
                  <option value={document.value} key={document.value}>
                    {document?.value?.length === 14
                      ? CnpjMask(document?.value)
                      : CpfMask(document?.value)}
                  </option>
                ))}
              </Select>
            </SelectContainer>
          </div>
        )}
      </div>
      <Button
        onClick={() => {
          signOut();
          navigate('/');
        }}
      >
        Sair
      </Button>
    </Container>
  );
};
